import { useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { selectUpdateNewsletters } from '@client/myAccount/newsletters/redux/redux';

export type UseUpdateNewslettersDataReturnType = RemoteRecord<Record<string, any>>;

export const useUpdateNewslettersData = (): UseUpdateNewslettersDataReturnType => (
  useSelector(selectUpdateNewsletters)
);
